import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  emoji: '📘',
  title: 'TOMO 1',
  subtitle: 'Reconexión con tu Energía Femenina',
  desc: 'El punto de partida de todo. La base que muchas mujeres nunca tuvieron. Entendés qué es la energía femenina en la práctica. Mapeás tu nivel de agotamiento real. Creás tus rituales de mañana y de noche. Y empezás a escuchar lo que tu cuerpo lleva años intentando decirte.',
  color: '#DFA0AD',
  bullets: ['Diagnóstico de vitalidad femenina', 'Ritual de mañana y cierre nocturno', 'Los 4 pilares del bienestar femenino', 'Ejercicios de escucha corporal', 'Tu primer mapa personal de bienestar']
}, {
  emoji: '📗',
  title: 'TOMO 2',
  subtitle: 'Alimentación Holística y Hábitos de Bienestar',
  desc: 'No es una dieta. Es un sistema de nutrición consciente diseñado para el cuerpo y el sistema nervioso femenino. Descubrís qué alimentos apoyan tu bienestar y cuáles lo drenan. Creás rutinas sostenibles. Y aprendés a usar la alimentación como un acto de amor propio cotidiano.',
  color: '#C4A882',
  bullets: ['Guía de alimentos antiinflamatorios para la mujer', 'La Leche Dorada y las infusiones femeninas de la Academia', 'Hábitos que alteran el equilibrio emocional y hormonal', 'El protocolo de hidratación consciente', 'Movimiento consciente para el bienestar femenino']
}, {
  emoji: '📙',
  title: 'TOMO 3',
  subtitle: 'Emociones, Estrés y Bienestar Consciente',
  desc: 'El tomo más transformador del método. El que más mujeres reportan que las hizo llorar de alivio. Entendés el impacto real del estrés crónico en el cuerpo femenino. Aprendés 6 técnicas de regulación nerviosa que podés usar en minutos. Y explorás la escritura terapéutica, la meditación y las visualizaciones para procesar lo que más tiempo lleva guardado.',
  color: '#B85C6E',
  bullets: ['El mapa completo del estrés crónico femenino', '6 técnicas de regulación nerviosa listas para usar', 'Escritura terapéutica profunda paso a paso', 'Meditación guiada completa de reconexión', 'Protocolo de autoexigencia y soltar el control']
}, {
  emoji: '📕',
  title: 'TOMO 4',
  subtitle: 'Energía, Chakras y Equilibrio Interior',
  desc: 'El plano que completa todo. El trabajo energético que transforma lo que la razón no puede. Conocés el sistema de chakras y su relación directa con el bienestar femenino. Trabajás en profundidad el chakra raíz y el chakra sacro. Y aprendés a usar cristales, aromaterapia, sonidos y auto-Reiki en rituales concretos.',
  color: '#9B7EA8',
  bullets: ['El sistema de chakras y el cuerpo femenino', 'Trabajo profundo con chakra raíz y chakra sacro', 'Guía completa de cristales para el equilibrio femenino', 'Rituales energéticos de luna nueva y luna llena', 'Auto-práctica de Reiki básico femenino']
}, {
  emoji: '📓',
  title: 'TOMO 5',
  subtitle: 'Pareja, Vínculos y Entorno Emocional',
  desc: 'El bienestar no ocurre en el vacío. Ocurre en vínculo. Aprendés a reconocer qué entornos te nutren y cuáles te drenan. Tenés herramientas concretas de comunicación consciente para la pareja. Y diseñás tus espacios seguros emocionales para sostenerte cuando todo se siente difícil.',
  color: '#A8C4A2',
  bullets: ['Auditoría completa del entorno emocional', 'Comunicación No Violenta aplicada a la pareja', 'Protocolo para manejar la presión familiar y social', 'Rituales semanales de reconexión de pareja', 'Tu ecosistema personal de bienestar vincular']
}, {
  emoji: '📔',
  title: 'TOMO 6',
  subtitle: 'Ritual Integral de Bienestar Femenino',
  desc: 'El programa de 21 días que convierte todo el método en un estilo de vida real, sostenible y tuyo. No más información suelta. Tenés un sistema diario, una rutina de mañana y de noche, un calendario holístico personalizado y el cierre energético del método que marca el umbral hacia tu nueva etapa.',
  color: '#D4A7A0',
  bullets: ['Programa completo de 21 días paso a paso', 'Rituales de mañana y noche en 3 niveles de profundidad', 'Tu protocolo personal de bienestar diseñado por vos', 'El Manifiesto de la Mujer Código Fértil', 'Ritual de cierre energético del método']
}];
const INCLUDES = ['Protocolos paso a paso', 'Ejercicios con guía completa', 'Páginas de journaling guiado', 'Técnicas listas para usar hoy', 'Checklists de implementación', 'Lenguaje femenino y argentino'];
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-brand-alternate py-8 md:py-10 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-242">
      <div className="container mx-auto max-w-4xl" data-id="element-243">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-244">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-brand-heading" data-id="element-245">
            🏆 MEGAPACK CÓDIGO FÉRTIL
          </h2>
          <p className="text-xl md:text-2xl text-brand-subheading font-bold mb-2" data-id="element-246">
            6 Tomos + 6 Bonos — Cuerpo · Emoción · Energía
          </p>
          <p className="text-brand-soft text-lg" data-id="element-247">
            Más de 600 páginas. Todo resuelto.
          </p>
        </div>

        <div className="text-center mb-5" data-id="element-248">
          <h3 className="text-2xl font-serif font-bold text-brand-heading tracking-widest uppercase" data-id="element-249">
            🌸 6 TOMOS COMPLETOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-250">
          {TOMOS.map((tomo, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-brand-card border border-brand-border-soft rounded-[16px] p-6 transition-all hover:shadow-medium shadow-soft ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 50}ms`,
            borderTopWidth: '4px',
            borderTopColor: tomo.color
          }} data-id="element-251">
                <div className="flex items-start gap-4 mb-4" data-id="element-252">
                  <span className="text-3xl" data-id="element-253">{tomo.emoji}</span>
                  <div data-id="element-254">
                    <h4 className="text-brand-accent font-bold text-sm tracking-widest uppercase mb-1" data-id="element-255">
                      {tomo.title}
                    </h4>
                    <h5 className="text-brand-heading font-serif font-bold text-xl mb-2 leading-tight" data-id="element-256">
                      {tomo.subtitle}
                    </h5>
                    <p className="text-brand-body text-sm leading-relaxed" data-id="element-257">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
                <div className="space-y-2 mt-4 pt-4 border-t border-brand-border-soft" data-id="element-258">
                  {tomo.bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-259">
                      <span className="text-sm mt-0.5" data-id="element-260">🌸</span>
                      <span className="text-brand-body text-sm" data-id="element-261">{bullet}</span>
                    </div>)}
                </div>
              </div>;
        })}
        </div>

        <div ref={ref2} className={`reveal bg-white border border-brand-border-soft rounded-[16px] p-6 md:p-8 text-center shadow-soft ${vis2 ? 'is-visible' : ''}`} data-id="element-262">
          <p className="text-brand-heading font-bold text-lg mb-4" data-id="element-263">
            Cada tomo incluye:
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-6" data-id="element-264">
            {INCLUDES.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-265">
                <span className="text-sm" data-id="element-266">🌸</span>
                <span className="text-brand-body text-sm font-medium" data-id="element-267">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}